import React from 'react';
import MakeModelEditModal from './make-model-edit-modal';

const EditMakeModelModal = ({ isOpen, onClose, data, refetchData }) => {
  return (
      <MakeModelEditModal
        isOpen={isOpen}
        onClose={onClose}
        data={data}
        refetchData={refetchData}
      />
  );
};

export default EditMakeModelModal;